var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"load_box"},[_c('van-loading',{attrs:{"type":"spinner","size":"24px","vertical":""}},[_vm._v("加载中...")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }